import React from "react";
import {
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

export default function PickupCard({
  pickupLocations = [],
  pickupLocation = "",
  isThreePlus = false,
  waiverAck = false,
  onSelectPickupLocation,
  onToggleWaiver,
}) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 3 }}>
      <CardContent sx={{ p: 2.25 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
          Pickup details
        </Typography>

        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel id="pickup-location-label">Pickup location</InputLabel>
          <Select
            labelId="pickup-location-label"
            label="Pickup location"
            value={pickupLocation}
            onChange={(e) => onSelectPickupLocation?.(e.target.value)}>
            {pickupLocations.map((loc) => (
              <MenuItem key={loc} value={loc}>
                {loc}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {isThreePlus && (
          <>
            <Alert severity="warning" sx={{ mt: 1.5 }}>
              3+ tier cakes are fragile to transport and may not fit typical
              coolers upright. We strongly recommend delivery & professional
              setup. If you still prefer pickup, please confirm below.
            </Alert>
            <FormControlLabel
              sx={{ mt: 1 }}
              control={
                <Checkbox
                  checked={!!waiverAck}
                  onChange={(e) => onToggleWaiver?.(e.target.checked)}
                />
              }
              label="I understand and accept the risks of picking up a 3+ tier cake."
            />
          </>
        )}
      </CardContent>
    </Card>
  );
}
